import { createAsyncThunk } from '@reduxjs/toolkit';
import { createMaskedValue } from '@/libs/helpers/utils';
import { DATE_MASK } from '@/libs/constants';
import { validateFlightDate } from '@/libs/validation/validateFlightDate';
import { validateFlightTime } from '@/libs/validation/validateFlightTime';
import { validateFlightDeparture } from '@/libs/validation/validateFlightDeparture';
import { FlightField } from './interface';
import { flightsActions } from './index';
export const setFlightDateFrom = createAsyncThunk('flights/setFlightDateFrom', async ({ _uuid, value }, thunkApi) => {
    const maskedValue = createMaskedValue(value, DATE_MASK);
    const { error } = validateFlightDate(maskedValue);
    thunkApi.dispatch(flightsActions._setFlightField({
        _uuid,
        field: FlightField.dateFrom,
        value: maskedValue,
    }));
    thunkApi.dispatch(flightsActions._setFlightFieldError({
        _uuid,
        field: FlightField.dateFrom,
        error,
    }));
    if (!error) {
        const state = thunkApi.getState();
        const flight = state.flights.flights.find((f) => f._uuid === _uuid);
        if (flight) {
            const { error: dateToError } = validateFlightDate(flight.dateTo, maskedValue);
            thunkApi.dispatch(flightsActions._setFlightFieldError({
                _uuid,
                field: FlightField.dateTo,
                error: dateToError,
            }));
            const { error: timeToError } = validateFlightTime(flight.timeTo, {
                dateFrom: maskedValue,
                dateTo: flight.dateTo,
                timeFrom: flight.timeFrom,
            });
            thunkApi.dispatch(flightsActions._setFlightFieldError({
                _uuid,
                field: FlightField.timeTo,
                error: timeToError,
            }));
            const { error: timeFromError } = validateFlightTime(flight.timeFrom);
            const { error: departureError } = validateFlightDeparture({
                dateFrom: maskedValue,
                timeFrom: flight.timeFrom,
            });
            thunkApi.dispatch(flightsActions._setFlightFieldError({
                _uuid,
                field: FlightField.timeFrom,
                error: timeFromError || departureError,
            }));
        }
    }
});
export const setFlightDateTo = createAsyncThunk('flights/setFlightDateTo', async ({ _uuid, value }, thunkApi) => {
    const maskedValue = createMaskedValue(value, DATE_MASK);
    const state = thunkApi.getState();
    const flight = state.flights.flights.find((f) => f._uuid === _uuid);
    const { error } = validateFlightDate(maskedValue, flight?.dateFrom);
    thunkApi.dispatch(flightsActions._setFlightField({
        _uuid,
        field: FlightField.dateTo,
        value: maskedValue,
    }));
    thunkApi.dispatch(flightsActions._setFlightFieldError({
        _uuid,
        field: FlightField.dateTo,
        error,
    }));
    if (!error && flight) {
        const { error: timeToError } = validateFlightTime(flight.timeTo, {
            dateFrom: flight.dateFrom,
            dateTo: maskedValue,
            timeFrom: flight.timeFrom,
        });
        thunkApi.dispatch(flightsActions._setFlightFieldError({
            _uuid,
            field: FlightField.timeTo,
            error: timeToError,
        }));
    }
});
